import axios from 'axios';
import server from '../serverUrl'
import { modal } from '../Components/ModalContext/ModalContext';

const getToken = () => localStorage.getItem('token');
const apiBaseUrl = server.server


const handleRequest = async (endpoint, formData, navigate = null) => {
  const token = getToken();

  if (!token) {
    if (navigate) navigate('/login');
    return 'No authentication token found. Redirecting to login.';
  }

  try {
    const response = await axios.post(`${apiBaseUrl}/${endpoint}`, formData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    if (error.message === 'Network Error') {
      modal.openModal("Network Error. Please check your internet connection.");
      return 'Error: Network Error - Redirecting to login';
    }

    if (error.response) {
      const status = error.response.status;
      const message = error.response.message;

      if ((status === 401 && message?.includes('jwt expired')) || message?.includes('TokenExpiredError')) {
        modal.openModal("jwt expired");
        return 'Session expired. Redirecting to login.';
      }

      return `Error: ${message || 'Request Failed'}`;
    }

    return 'Network error. Please try again.';
  }
};

const handleLogout = (navigate) => {
  localStorage.clear()
  navigate("/");
  window.location.reload();
};
const chatService = {
  createChat: (formData, navigate) => handleRequest('createChat', formData, navigate),
  findChat: (formData, navigate) => handleRequest('findChat', formData, navigate),
  createMessage: (formData, navigate) => handleRequest('createMessage', formData, navigate),
  findUserChats: (formData, navigate) => handleRequest('findUserChats', formData, navigate),
  getMessagesWithChatId: (formData, navigate) => handleRequest('getMessagesWithChatId', formData, navigate),
  getMessages: (formData, navigate) => handleRequest('getMessages', formData, navigate),
  updateMessage: (formData, navigate) => handleRequest('updateMessage', formData, navigate),
  handleLogout,
};

export default chatService;

